/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/10/22, 1:27 PM
 *
 */

import { ApiResponse } from 'types/api';
import { Role } from 'types/RoleTypes';

import { privateAgent } from 'config/axios';

export const getRoleDetails = async (roleId: number): Promise<Role> => {
  const response = await privateAgent.get<ApiResponse<Role>>(`role/detail/${roleId}`);
  return response?.data?.data;
};
